import React, { useState } from "react";
import CesiumJS from "./CesiumJS";
import styled from "styled-components";
import ControlDock from "../components/CesiumUtil/ControlDock";
import { useTilesetStore } from "../Store/store";

const CesiumPageContainer = styled.div`
  width: 100%;
  height: 100vh;
`;

export default function CesiumPage() {
  const { isTilesetLoaded, setIsTilesetLoaded } = useTilesetStore();

  return (
    <CesiumPageContainer>
      <CesiumJS />
      {/* {isTilesetLoaded && <ControlDock />} */}
      <ControlDock />
    </CesiumPageContainer>
  );
}
